// extracted by mini-css-extract-plugin
export default {"ad":"plrgR"};